<template>
    <div class="CaseCard">
      <div class="Content">
        <h2 style="text-align: center; margin-bottom: 20px;">案例基本信息</h2>
        <div class="info-block">
          <strong>案例名称：</strong>
          <span>{{ caseInfo.name }}</span>
        </div>
        <div class="info-block">
          <strong>案例作者：</strong>
          <span>{{ caseInfo.author }}</span>
        </div>
        <div class="info-block">
          <strong>案例企业名称：</strong>
          <span>{{ caseInfo.companyName }}</span>
        </div>
        <div class="info-block">
          <strong>案例企业所属行业及规模：</strong>
          <span>{{ caseInfo.industryAndScale }}</span>
        </div>
        <div class="info-block">
          <strong>适用课程：</strong>
          <span>{{ caseInfo.courses }}</span>
        </div>
        <div class="info-block">
          <strong>案例知识点：</strong>
          <span>{{ caseInfo.keywords }}</span>
        </div>

        <!-- 添加附件列表 -->
        <div class="info-block">
          <strong>附件列表：</strong>
          <div v-if="caseInfo.files && caseInfo.files.length > 0">
            <ul>
              <li v-for="attachment in caseInfo.files" :key="attachment.id">
              <!-- 点击事件绑定到 downloadFile 方法 -->
              <a href="javascript:void(0);" @click="handleDownload(attachment)">
                {{ attachment.name }}
              </a>
            </li>
            </ul>
          </div>
          <div v-else>
            <span>暂无附件</span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    getCaseById,
    CaseDownloadCountAdd
    } from "@/api/views/caselibrary";

  export default {
    data() {
      return {
        caseInfo: {
          name: '', // 案例名称
          author: '', // 案例作者
          companyName: '', // 案例企业名称
          industryAndScale: '', // 案例企业所属行业及规模
          courses: '', // 适用课程
          keywords: '' // 案例知识点
        }
      };
    },
    mounted() {
      this.fetchCaseInfo();
    },
    methods: {
     // 处理下载逻辑
    async handleDownload(attachment) {
      try {
        let params={};
        params.case_id =  Number(this.$router.currentRoute.query.caseID);

        // 调用接口增加下载量
       await  CaseDownloadCountAdd(params);

        // 跳转到实际的下载地址
        //window.location.href = attachment.url;
        window.open(attachment.url, '_blank');
        // 提示用户
        this.$message.success(`正在下载文件：${attachment.name}`);
      } catch (error) {
        // 处理错误
        console.error("增加下载量失败", error);
        this.$message.error(`下载文件 ${attachment.name} 失败，请稍后再试`);
      }
    },
        fetchCaseInfo(){

            let params={};
            params.case_id =  Number(this.$router.currentRoute.query.caseID);
            getCaseById(params).then(result => {
                this.caseInfo.name=result.data.CaseName;
                this.caseInfo.author=result.data.CaseAuthor;
                this.caseInfo.companyName=result.data.CompanyName;
                this.caseInfo.industryAndScale=result.data.Industry;
                this.caseInfo.courses=result.data.Courses;
                this.caseInfo.keywords=result.data.CaseKnowledgePoints;


                if(result.data.files!==null){

                    try{

                      const filesArray = JSON.parse(result.data.files);
                      this.caseInfo.files = filesArray; // 将解析后的数组赋值给 fileList

                    }catch{
                      this.caseInfo.files=[];
                    }
                    }

                }).catch(error => {
                        console.error('Error fetching case info:', error);
                });
        }
 

    }
  };
  </script>
  
  <!-- <style scoped>
 
  h2 {
    color: red;
  }
  p {
    margin: 10px 0;
  }

  .CaseCard {
         display: flex;
        justify-content: center;
        align-items: center;
        height: 100vh;
        background-color: #f5f5f5;
        
  }

  .Content{
    background-color: #ffffff;
          border: 1px solid #ddd;
          border-radius: 8px;
          padding: 20px;
          width: 80%;
          max-width: 600px;
          font-family: SimSun, serif;
          font-size: 16px; /* 4号字体大小 */
          line-height: 1.5; /* 单倍行距 */
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  }


  </style> -->

  <style scoped>
  /* 添加一些样式 */
  h2 {
    color: #333;
    font-size: 20px;
  }
  
  .info-block {
    display: flex;
    align-items: flex-start; /* 让标题和内容第一行对齐 */
    margin: 15px 0;
    padding: 10px;
 /*    background-color: #f9f9f9; 
    border: 1px solid #ddd;*/
    border-radius: 5px;
  }
  
  .info-block strong {
    font-weight: bold;
    color: #555;
    margin-right: 10px;
    white-space: nowrap; /* 防止标题换行 */
    width: 200px;
  }
  
  .info-block span {
    flex: 1;
    color: #333;
  }
  
  .CaseCard {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
  }
  
  .Content {
    background-color: #ffffff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 20px;
    width: 90%; /* 增加宽度 */
    max-width: 800px; /* 增加最大宽度 */
    font-family: Arial, sans-serif;
    font-size: 16px;
    line-height: 1.5;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  </style>